// extracted by mini-css-extract-plugin
module.exports = {"search-engine":"Search_search-engine__2P0pV","search-word":"Search_search-word__1bWpw","word":"Search_word__QWCwU","loader":"Search_loader__3bAOZ"};